export default __webpack_public_path__ + "be5e06ef7dacf42828e4472d5f45aa50.png";